var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-placeholder-wrap"},[_c('div',{staticClass:"module-placeholder"},[_vm._v(" 「"+_vm._s(_vm.title)+"」配置（静态占位，待接入） ")])])}
var staticRenderFns = []

export { render, staticRenderFns }